export default "__VITE_ASSET__jJV4QKnI__"